import React from "react";
import {Section} from './Section'
import {resolve} from '@q4us-sw/q4us-ui/lib/Cell'
import {fetchDocument} from '../../api/api'
import {Tag, Space, Typography} from 'antd'

export const AdditionalInfo = ({data,fetchConfig,onChange=()=>{}})=>{

    const [values,setValues] = React.useState(data)

    return <Section
        title={"Additional Information"}
        data={data}
        schema={"reg_approval_additional_info"}
        onChange={(val)=>{
            setValues(val)
        }}
        isEditable={(cfg, v)=>{
            return false;
        }}
        fetchConfig={async ()=>{
            return await fetchConfig({schema: "reg_approval_additional_info"})
        }}
        resolve={(props)=>{
            switch (props.name){
                case "self_reg_document":
                    return <Space direction={"vertical"}>
                        {
                            (values.self_reg_document||[]).map(({file, id, category})=>{
                                return <Space>
                                    <Tag color={"green"} style={{width: 155,textAlign: "center"}}>{category.toUpperCase()}</Tag>
                                    <Typography.Link
                                        onClick={async ()=>{await fetchDocument(values.id, id,file)}}
                                    >
                                        {(file || "File not uploaded")}
                                    </Typography.Link>
                                </Space>
                            })
                        }

                    </Space>
                default:
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
            }
        }}
    />
}
